export default {
  allAlternativeContracts: state => {
    return state.alternativeContracts || [];
  },
  getCurrentAlternativeContract: state => {
    return state.currentAlternativeContract || {};
  },
  getAltContractState: state => {
    return state.isAltContractRawEditing;
  },
  getAlternativeKinds: state => {
    return state.alternativeKinds;
  },
  getAlternativeLessors: state => {
    return state.addedAlternativeLessorsIds || [];
  }
};
